import * as React from "react";
import { useRegistrationContext } from "../Contexts/RegistrationContext";
import { Checkbox } from "../Elements/Checkbox";
import "./ConditionsForm.scss";

export const ConditionsForm = (): JSX.Element => {
    const { setConditionAgreed } = useRegistrationContext();

    return (
        <div className="conditions-form">
            <div className="conditions-text">
                <br />
                Uzturoties mežā, ievēro LVM izstrādātos Labas uzvedības noteikumus
                (www.lvm.lv/sabiedribai/ko-drikst-meza/labas-uzvedibas-noteikumi) un Meža likuma 6. pantā noteiktās
                prasības un ierobežojumus: VISPĀRĒJIE UZVEDĪBAS NOTEIKUMI MEŽĀ. <br />• Ievēro savstarpējo cieņu,
                netraucē, netrokšņo un neapdraudi citus meža apmeklētājus. <br />• Nebojā īpašumu, piemēram, meža ceļus
                un grāvjus, izziņas un rekreācijas infrastruktūru. <br />• Ievēro papildus noteikumus atpūtas vietās,
                kas ierīkotas cilvēkiem ar kustību traucējumiem un dabā atzīmētas ar informatīvām zīmēm. <br />• Esi
                saudzīgs pret dabu – apzināti netraucē putnus un dzīvniekus (īpaši pavasarī), neposti putnu ligzdas un
                citu dzīvnieku dzīvotnes, skudru pūžņus, nebojā augošus kokus un krūmus. <br />• Aizsargājamās dabas
                teritorijās ievēro papildus prasības un ar izpratni izturies pret ierobežojumiem, kas noteikti, lai
                aizsargātu dabu. <br />• Pārvietojoties kopā ar suni, ievēro pašvaldību saistošos noteikumus un respektē
                tūrisma vietā izvietotās zīmes. <br />• Neposti meža augsni un zemsedzi. <br />• Ievēro meža
                ugunsdrošības noteikumus. <br />• Nepiesārņo mežu ar atkritumiem, ievēro noteikto kārtību atpūtas vietu
                izmantošanā. <br />• Atrodot izmestus sadzīves atkritumus, izvērtē savas iespējas tos pacelt, iznest no
                meža un nogādāt sadzīves atkritumu konteinerā. Lielāka piesārņojuma gadījumā ziņo VIDES SOS. <br />•
                Nemazgā dabā, sevišķi pie ūdenstilpnēm, mehāniskos transporta līdzekļus. <br />• Respektē LVM darbinieku
                norādījumus. <br />• Izvēlies košu un pamanāmu apģērbu, pārvietojoties mežā vai pa ceļu, īpaši sliktas
                redzamības apstākļos. <br />• Netuvojies vietai, kur ir redzams, dzirdams, ka notiek medības.
                <br />• Ievēro uzstādītās brīdinājuma zīmes, netuvojies meža darbu vietām, ja tiek izmantoti
                motorinstrumenti vai mašīnas, būvobjektu (meža ceļi vai citi meža infrastruktūras objekti) teritorijai
                un derīgo izrakteņu ieguves vietām, nepeldies derīgo izrakteņu ieguves vietās esošajās ūdenstilpēs.
                <br />• Pievērs uzmanību drošībai, kad atrodies tuvu ugunsgrēka vietām un degumiem, kokmateriālu grēdām,
                bīstamiem kokiem.
            </div>
            <Checkbox
                label={"Apņemos ievērot nosacījumus"}
                defaultChecked={false}
                required={true}
                onChange={setConditionAgreed}
            ></Checkbox>
        </div>
    );
};
